// extracted by mini-css-extract-plugin
export default {"root":"yjazBn","img":"qJeFUr"};